import React, { useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'
import { NavLink, useLocation } from 'react-router-dom'

const TabsWrapper = styled.div`
  display: flex;
  align-items: center;
  font-family: Baloo Da;
  width: 892px;
  padding-top: 10px;
  padding-bottom: 30px;
  overflow-x: scroll;
  ${({ theme }) => theme.mediaWidth.upToLarge`
    display: block;
    width: 100%;
    overflow-x: auto;
    white-space: nowrap;
    // height: 56px;
    // overflow-y: visible;
    justify-content: center;
  `}
`

const activeclass = 'ACTIVENAV'
const TabItem = styled(NavLink).attrs({
  activeclass
})`
  position: relative;
  color: ${({ theme }) => theme.bsText2};
  font-size: 22px;
  font-weight: bold;
  text-decoration: none;
  white-space:nowrap;
  margin-right: 40px;

  &.${activeclass} {
    color: ${({ theme }) => theme.text1};
    font-size: 22px;
    &:after {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      background: ${({ theme }) => theme.text1};
      border-radius: 2px;
      width: 100%;
      height: 4px;
    }
  }

  ${({ theme }) => theme.mediaWidth.upToSmall`
    font-size: 14px;
    margin-right: 16px;
    &.${activeclass} {
      font-size: 14px;
    }
  `};
`
// const Comingsoon = styled.div`
//   position: relative;
//   color: ${({ theme }) => theme.bsText2};
//   font-size: 22px;
//   font-weight: bold;
//   text-decoration: none;
//   ${({ theme }) => theme.mediaWidth.upToSmall`
//     font-size: 14px;
//   `}
// `
// const IconSub =  styled.img`
// position: absolute;
// top: -10px;
// right: -51px;
// `
const IconFlag =  styled.img`
  position: absolute;
  top: -10px;
  right: -15px;
`

export default function Tabs() {
  const location = useLocation()
  const theme = useContext(ThemeContext)

  return (
    <TabsWrapper>
      <TabItem to={'/gamification/gameace'} className={location.pathname.indexOf('/gamification/gameace') >= 0 ? activeclass : ''}>
        GameAce
        <IconFlag src={'/images/icon_new' + (theme.darkMode ? '_light' : '') + '.svg'} width={24} />
      </TabItem>
      <TabItem to={'/gamification/muskUsmLand'} className={location.pathname.indexOf('/gamification/muskUsmLand') >= 0 ? activeclass : ''}>
        MPB USM LAND
      </TabItem>
      <TabItem to={'/gamification/bakeMuskMixer'} className={location.pathname.indexOf('/gamification/bakeMuskMixer') >= 0 ? activeclass : ''}>
        Bake Musk Mixer
      </TabItem>
      <TabItem to={'/gamification/equipment'} className={location.pathname.indexOf('/gamification/equipment') >= 0 ? activeclass : ''}>
        Doggy Equipment
      </TabItem>
      <TabItem to={'/gamification/matrix'} className={location.pathname.indexOf('/gamification/matrix') >= 0 ? activeclass : ''}>
        Matrix Plus Box
      </TabItem>
      <TabItem to={'/gamification/poker'} className={location.pathname.indexOf('/gamification/poker') >= 0 ? activeclass : ''}>
        Poker BlindBox
      </TabItem>
      <TabItem to={'/gamification/barking'} className={location.pathname.indexOf('/gamification/barking') >= 0 ? activeclass : ''}>
        Barking Shop
      </TabItem>
      <TabItem to={'/gamification/doggies'} className={location.pathname.indexOf('/gamification/doggies') >= 0 ? activeclass : ''}>
        Crypto Doggy Shop
      </TabItem>
      {/* <TabItem to={'/gamification/gifbox'} className={location.pathname.indexOf('/gamification/gifbox') >= 0 ? activeclass : ''}>
        Rare Gift Box
        <IconFlag src={'/images/icon_new' + (theme.darkMode ? '_light' : '') + '.svg'} width={24} />
      </TabItem> */}
      <TabItem to={'/gamification/car'} className={location.pathname.indexOf('/gamification/car') >= 0 ? activeclass : ''}>
        Rare Car Collection
      </TabItem>
      <TabItem to={'/gamification/gameBox'} className={location.pathname.indexOf('/gamification/gameBox') >= 0 ? activeclass : ''}>
        Game Box
      </TabItem>
      <TabItem to={'/gamification/soccer'} className={location.pathname.indexOf('/gamification/soccer') >= 0 ? activeclass : ''}>
        Soccer
      </TabItem>
      <TabItem to={'/gamification/combomeal'} className={location.pathname.indexOf('/gamification/combomeal') >= 0 ? activeclass : ''}>
        Combo meals
      </TabItem>
    </TabsWrapper>
  )
}